import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./context/ThemeContext"; // Import ThemeProvider
import { SoundProvider } from "./context/SoundContext"; // Import SoundProvider
import "./firebaseConfig"; // Initialize Firebase

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Wrap your App in the router */}
    <BrowserRouter>
      <ThemeProvider>
        <SoundProvider>
          <App />
        </SoundProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
